import type CK from '~/types/contentking';

import {
	useAccountCanHaveMoreConnectedTrialAccountsQuery,
} from './useAccountCanHaveMoreConnectedTrialAccounts.gql';

import useAccountPropertiesQuery from '~/hooks/useAccountPropertiesQuery';



function useAccountCanHaveMoreConnectedTrialAccounts(accountId: CK.AccountId | null) {
	const { data } = useAccountPropertiesQuery(
		useAccountCanHaveMoreConnectedTrialAccountsQuery,
		accountId,
	);

	return data?.account?.canHaveMoreConnectedTrialAccounts ?? null;
}



export default useAccountCanHaveMoreConnectedTrialAccounts;
